import React, { useState, useEffect } from "react";
import { weather } from "../../src/api/user";
import LiquidContainer from "../components/LiquidContainer";
import sunny from "../assets/icons/weather/Sunny.svg";
import clowdy from "../assets/icons/weather/Cloudy.svg";
import snowing from "../assets/icons/weather/Snowing.svg";
// import wind from "../../assets/icons/weather/VeryCloudy.svg";
import storm from "../assets/icons/weather/Storm.svg";
// import fog from "../assets/icons/weather/Fog.svg";

const WeatherWidget = () => {
  const [todayWeather, setTodayWeather] = useState(null);

  useEffect(() => {
  const fetchWeather = async () => {
    try {
      const result = await weather();

      if (result["7_day_forecast"]?.length > 0) {

        const today = new Date().toISOString().split("T")[0];

        // DEBUG LOGS HERE
        // console.log("Today:", today);
        // console.log("Forecast:", result["7_day_forecast"]);

        const todayForecast = result["7_day_forecast"].find(day =>
          day.date.startsWith(today)
        );

        // console.log("Matched forecast:", todayForecast);

        setTodayWeather(todayForecast || result["7_day_forecast"][0]);
      }

    } catch (err) {
      console.error("Weather error:", err);
    }
  };

  fetchWeather();
}, []);;

const getIcon = (condition) => {
  if (!condition) return clowdy;

  const c = condition.toLowerCase();

  if (c.includes("storm")) return storm;

  if (c.includes("snow") || c.includes("powder"))
    return snowing;

  if (c.includes("bluebird")) return sunny;

  if (c.includes("fog")) return clowdy;

  return clowdy;
};

const formatDate = (dateString) => {
  const [year, month, day] = dateString.split("-");
  const date = new Date(year, month - 1, day); // local date (no UTC shift)

  const options = { weekday: "short", month: "short", day: "numeric" };
  return date.toLocaleDateString("es-MX", options);
};
  if (!todayWeather) return null;

  const avgTemp = Math.round(
    (todayWeather.temperature_max + todayWeather.temperature_min) / 2
  );

  return (
    <div className="row m-0 p-0"
      style={{
        backdropFilter: "blur(12px)",
        background: "rgba(207, 206, 206, 0.3)",
        borderRadius: "18px",
        padding: "10px 14px",
        color: "white",
        display: "flex",
        alignItems: "right",
        gap: "10px",
        fontSize: "14px",
        minWidth: "100px",
        maxHeight: "120px",
        width: "35vw",
        boxShadow: "0 5px 9px rgba(0, 0, 0, 0.32)"
      }}
    >
<div className="col m-0 p-0">

        <div className="row m-0 pe-2">
            <div className="col d-flex justify-content-center align-items-center m-0 p-0">
                <h2 className="m-0 p-0 text-center" style={{ fontWeight: "800" }}>{avgTemp}°</h2>
            </div>
            <div className="col m-0 pt-2">
                <img 
                    className="img-fluid"
                    src={getIcon(todayWeather.ski_condition)}
                    alt="weather"
                    style={{maxHeight: "35px"}}
                />
            </div>
        </div>

        <div className="row m-0 p-0">
            <div className="col text-left m-0 ps-2">
                <div style={{ fontSize: "16px", opacity: 0.9 }}>
          {todayWeather.weather_description}
        </div>
            </div>
        </div>

        <div className="row m-0 p-0">
            <div className="col m-0 ps-2 pb-2">
                <div style={{ fontSize: "14px", opacity: 0.8 }}>
          Máx: {todayWeather.temperature_max}° Min: {todayWeather.temperature_min}°
        </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherWidget;